import { createSelector } from 'reselect';

const selecttenantDomainFunctionEntities = (state: any) => state.tenantDomainFunctionEntities;


export const selecttenantDomainFunctionEntitiesCurrentItem = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.current);

export const selecttenantDomainFunctionEntitiesListItems = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.list);

export const selectItemById = (itemId: any) =>
    createSelector(selecttenantDomainFunctionEntitiesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selecttenantDomainFunctionEntitiesQueryItems = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.query);

export const selecttenantDomainFunctionEntitiesCreatedItem = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.create);

export const selecttenantDomainFunctionEntitiesUpdatedItem = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.update);

export const selecttenantDomainFunctionEntitiesReadItem = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.read);

export const selecttenantDomainFunctionEntitiesDeletedItem = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.delete);

export const selecttenantDomainFunctionEntitiesSearchedItems = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.search);

export const selecttenantDomainFunctionEntitiesItemsCount = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.count);

export const selecttenantDomainFunctionEntitiesItemsFilter = createSelector([selecttenantDomainFunctionEntities], (tenantDomainFunctionEntities) => tenantDomainFunctionEntities.filter);